import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// Mock-Daten für Testzwecke
const mockUsers = [
  { username: "admin", password: "password" },
  { username: "testuser", password: "test1234" },
];

function LoginPage() {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [showResetPassword, setShowResetPassword] = useState(false); // Zustand für "Passwort vergessen" anzeigen
  const navigate = useNavigate(); // React Router Hook

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); // Fehler zurücksetzen
    setSuccessMessage(""); // Erfolgsmeldung zurücksetzen
    setShowResetPassword(false);
  
    try {
      const response = await fetch("https://www.denisbitter.de/stage01/api/login_user.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
  
      const textResponse = await response.text(); // Holen der rohen Text-Antwort
      console.log("Rohe Antwort:", textResponse); // Logge die rohe Antwort
  
      let data;
      try {
        data = JSON.parse(textResponse); // Versuche, die Antwort als JSON zu parsen
      } catch (err) {
        console.error("Ungültiges JSON-Format:", err);
        setError("Die Antwort vom Server konnte nicht verarbeitet werden.");
        return;
      }
  
      // Debug-Log für die API-Antwort
      console.log("API Antwort:", data);
  
      if (data.success) {
        setSuccessMessage(data.message || "Login erfolgreich!");
        navigate("/course-list"); // Weiterleitung zur Kursübersicht
      } else {
        setError(data.message || "Benutzername oder Passwort ist falsch.");
        setShowResetPassword(true);
      }
    } catch (err) {
      console.error("Fehler:", err);
      setError("Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.");
      setShowResetPassword(true);
    }
  };

  const handleForgotPassword = () => {
    navigate("/forgot-password"); // Weiterleitung zur Seite "Passwort vergessen"
  };

  return (
    <div className="min-h-screen bg-gradient-to-r from-blue-500 to-pink-500 flex items-center justify-center">
      <div className="bg-white shadow-lg rounded-lg p-8 max-w-md w-full">
        <h2 className="text-2xl font-bold mb-6 text-gray-800 text-center">Login</h2>
        {error && (
          <div className="bg-red-100 text-red-600 p-4 mb-4 rounded text-sm">
            {error}
          </div>
        )}
        {successMessage && (
          <div className="bg-green-100 text-green-600 p-4 mb-4 rounded text-sm">
            {successMessage}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label
              htmlFor="username"
              className="block text-gray-700 text-sm font-bold mb-2"
            >
              Benutzername
            </label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-gray-900"
            />
          </div>
          <div className="mb-6">
            <label
              htmlFor="password"
              className="block text-gray-700 text-sm font-bold mb-2"
            >
              Passwort
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-gray-900"
            />
          </div>
          <button
            type="submit"
            className="w-full bg-gray-800 text-white font-bold py-2 px-4 rounded hover:bg-pink-500 transition duration-300"
          >
            Einloggen
          </button>
        </form>
        {showResetPassword && (
          <div className="mt-4 text-center">
            <button
              onClick={handleForgotPassword}
              className="text-blue-500 hover:underline font-medium block"
            >
              Passwort vergessen?
            </button>
          </div>
        )}
        <div className="mt-4 text-center">
          <p className="text-sm text-gray-600">
            Noch kein Konto?{" "}
            <a
              href="/register"
              className="text-blue-500 hover:underline font-medium"
            >
              Registrieren
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;